import React from 'react';
import {
  DateTime,
} from 'luxon';

import * as S from '../../styled';

const formatDate = (isoDay, f) => DateTime.fromISO(isoDay).toFormat(f);

type Props = {
  workouts: any[],
  withStatus: boolean,
};

const Table = ({ workouts, withStatus }: Props) => (
  <table>
    <thead>
      <tr>
        <th>Workout</th>
        <th>Date</th>
        <th>Time</th>
        {withStatus && (
          <th>Status</th>
        )}
      </tr>
    </thead>
    <tbody>
      {workouts.map(ev => (
        <tr key={ev.id}>
          <td>
            <S.ThLink to={`/events/${ev.id}`}>
              {ev.workout_name}
            </S.ThLink>
          </td>
          <td>{formatDate(ev.begins_at, 'MMM dd')}</td>
          <td>{formatDate(ev.begins_at, 'T')}</td>
          {withStatus && (
            <td>
              {ev.is_completed ? (
                <S.WorkoutComplete />
              ) : (
                <S.WorkoutInComplete />
              )}
            </td>
          )}
        </tr>
      ))}
    </tbody>
  </table>

);

export default Table;
